import { Controller } from "stimulus"
import Tobi from '@rqrauhvmra/tobi'

export default class extends Controller {
  connect() {
    new Tobi({
      zoom: false
    });
  }
}